<template>
  <vx-card no-shadow v-if="showWindow">
    <vs-table max-items="5" pagination :data="tableData">
            <template slot="thead">
                <vs-th v-for="(item,index) in fieldsHead" :key="index">{{item}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td  v-for="(item,index) in fieldsHead" :key="index" :data="data[indextr][item]">
                        {{data[indextr][item]}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
  </vx-card>
</template>

<script>
import axios from "@/axios.js"
export default {
  data() {
    return {
      params: {},
      tableData:[],
      fieldsHead: []
    }
  },
  components:{
  },
  computed: {
    showWindow(){
      if(this.$route.path.indexOf('/brokers/')!==-1){
        //if(this.fieldsData.length===0)
          this.setData();
        return true;
      }
      return false;
    },
  },
  methods:{
    setData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 1);
      params.append('uname', this.$route.params.brokerId);
      axios.post("/api/brokers",params)
      .then((response) => {
        that.tableData.splice(0);
        for(let i in response.data){
          let data = JSON.parse(response.data[i].object);
          if(that.fieldsHead.length===0){
              for(let i in data){
                  that.fieldsHead.push(i);
              }
          }
          that.tableData.push(data);
        }
      })
      .catch((error) => { console.log('error',error) })
    },
  }
}
</script>
